import React from 'react';
import { get } from 'lodash';
import { withProps } from 'recompose';
import { Breadcrumbs, Crumb } from 'components/core/Breadcrumbs';

import './facilityBreadcrumbs.scss';

export const enhance = withProps(
	({ facility }) => ({
		className: 'facility-breadcrumbs',
		location: facility.seoLocation,
		cityUrl: get(facility, 'url.city'),
		stateUrl: get(facility, 'url.state'),
		crumbs: facility.name && facility.url ? [
			<Crumb
				key="facility"
				label={facility.name}
				href={facility.url.facility}
				isLast
			/>
		] : []
	})
);

export default enhance(Breadcrumbs);
